function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

/**
 * Kaching Bundles owns the real price on bundle PDPs, so the Shop Pay installments copy
 * has to quote a quarter of the BUNDLE TOTAL (what the shopper is charged for the whole
 * bundle) rather than a quarter of the unit price.
 *
 * Kaching renders two different bar layouts across this store, so the total lives in
 * different places:
 *   - multi-row bars (e.g. /products/bph2): the per-unit price sits in the `--main`
 *     pricing row ("$27.99 per bag") and the bundle TOTAL in a `--secondary` row
 *     ("$55.98"); both use `.kaching-bundles__bar-price`.
 *   - single-row bars (e.g. /products/ppl2): `.kaching-bundles__bar-price` is ALREADY
 *     the bundle total ("$150.00" for a 4-pack) and the per-unit price is a bare
 *     `.money` node ("$37.50 each pair"); there is no `--secondary` row.
 *
 * The one thing that holds in every layout: the bundle total is the LARGEST current
 * (sale) price the bar prints — the struck-through original is a separate
 * `.kaching-bundles__bar-full-price`, so it's excluded. So take the max of the bar's
 * `.kaching-bundles__bar-price` values and NEVER multiply by quantity (the total is
 * already the full-bundle figure — multiplying double-counted it on ppl2).
 *
 * @param {Element} [bar] bundle bar to read; defaults to the currently selected one.
 *                        Pass the clicked bar explicitly — Kaching sets the
 *                        `--selected` class asynchronously.
 * @returns {number|null} total in cents, or null if the widget isn't readable.
 */
function getKachingBundleTotalCents(bar) {
  if (!bar) {
    // The subscribe checkbox/cards are `.kaching-bundles__bar`s too — never price off them.
    bar = Array.from(document.querySelectorAll('.kaching-bundles__bar--selected')).filter(
      (el) => !el.closest('.kaching-bundles__subscriptions')
    )[0];
  }
  if (!bar || bar.closest('.kaching-bundles__subscriptions')) return null;

  const money = (el) => (el ? parseFloat((el.textContent || '').replace(/[^0-9.,]/g, '').replace(/,/g, '')) : NaN);

  // `.kaching-bundles__bar-price` only ever holds current (sale) prices; the struck-through
  // original lives in `.kaching-bundles__bar-full-price`, so it's already excluded here.
  var prices = Array.from(bar.querySelectorAll('.kaching-bundles__bar-price'))
    .map(money)
    .filter((n) => !isNaN(n) && n > 0);

  if (!prices.length) return null;
  return Math.round(Math.max.apply(null, prices) * 100);
}


document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    const setViewportHeight = () => document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    setViewportHeight();
    window.addEventListener('resize', setViewportHeight);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.pagination = this.querySelector('.slider-pagination'); //new pagination
    this.paginationLinks = this.querySelectorAll('.slider-pagination-link'); //new pagination

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.resetPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    // this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.slidesPerPage = this.slider.clientWidth / this.sliderItemOffset;
    if(this.slidesPerPage > 0.7 && this.slidesPerPage < 1){
      this.slidesPerPage = 1;
    }else{
      this.slidesPerPage = Math.floor(this.slidesPerPage);
    }
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    // console.log("sliderItemsToShow", this.sliderItemsToShow)
    // console.log("this.slidesPerPage", this.slidesPerPage)
    // console.log("this.totalPages", this.totalPages);
    // console.log("this.pagination", this.pagination);

    // new feature - pagination CRO update
    if(this.pagination){
      if(!this.querySelector('.slider-pagination-link')){
        for (let i = 0; i < this.totalPages; i++) {
          let paginationLink = document.createElement('span');
          paginationLink.classList.add('slider-pagination-link');
          paginationLink.setAttribute('data-page', i);
          this.pagination.appendChild(paginationLink);
        }
      }else{
        // AB-TEST:bpm-gallery-v1 — the block gallery keeps every variant's slides in the DOM
        // (hidden via CSS), so count only the VISIBLE ones; otherwise the dots multiply to one
        // per hidden slide. Scoped to the pillow's deterministic gallery.
        if(this.closest('media-gallery[data-bpm-variant]')){
          this.sliderItemsToShow = Array.from(this.slider.querySelectorAll('li')).filter(el => el.clientWidth > 0);
        }else{
          this.sliderItemsToShow = this.slider.querySelectorAll('li');
        }
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        if(this.querySelectorAll('.slider-pagination-link').length != this.totalPages){
          this.querySelectorAll('.slider-pagination-link').forEach((el)=>{
            el.remove();
          })
          for (let i = 0; i < this.totalPages; i++) {
            let paginationLink = document.createElement('span');
            paginationLink.classList.add('slider-pagination-link');
            paginationLink.setAttribute('data-page', i);
            this.pagination.appendChild(paginationLink);
          }
        }else{
          this.querySelectorAll('.slider-pagination-link.pagination-hidden').forEach((pagination)=>{
            pagination.classList.remove('pagination-hidden');
          })
        }
      }
    }

    // console.log("this.paginatio", this.pagination);
    // console.log("this.paginationLinks", this.paginationLinks)
    
    this.paginationLinks = this.querySelectorAll('.slider-pagination-link');
    
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    // new feature - pagination CRO update
    if(this.pagination){
      var activeLink = this.querySelector('.active');
      if (activeLink) {
        activeLink.classList.remove('active');
      }
      
      if(this.paginationLinks.length){
        this.paginationLinks[this.currentPage - 1].classList.add('active');
      }
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if(this.slider.classList.contains('thumbnail-list')){
      this.sliderItemsToShow = document.querySelectorAll('.thumbnail-list.slider li');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

var fixedViewsImages1 = [];
var fixedThumbImages1 = [];
var fixedViewsImages2 = [];
var fixedThumbImages2 = [];
var mediaGalleryViewsWrapper = document.querySelectorAll(`.product__media-list.slider`);
var mediaGalleryViews1 = mediaGalleryViewsWrapper[0]?.querySelectorAll(`li.product__media-item`);
var mediaGalleryViews2 = mediaGalleryViewsWrapper[1]?.querySelectorAll(`li.product__media-item`);
var mediaGalleryViews3 = mediaGalleryViewsWrapper[2]?.querySelectorAll(`li.product__media-item`);
var mediaGalleryThumbsWrapper = document.querySelectorAll(`.thumbnail-list.slider`);
var mediaGalleryThumbs1 = mediaGalleryThumbsWrapper[0]?.querySelectorAll(`.thumbnail-list__item`);
var mediaGalleryThumbs2 = mediaGalleryThumbsWrapper[1]?.querySelectorAll(`.thumbnail-list__item`);
var mediaGalleryThumbs3 = mediaGalleryThumbsWrapper[2]?.querySelectorAll(`.thumbnail-list__item`);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    addEventListener("DOMContentLoaded", (event) => {
      this.pillowColorOption();
      this.pillowColorImageChange();
      this.hideOtherMedia();
      this.shopPayMessageUpdate();
      this.updateMedia();
      this.updateGlobalColorLabel();
      this.updateDynamicVariantNameTxt();
    });
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.pillowColorImageChange();
      this.updateMedia();
      this.hideOtherMedia();
      this.shopPayMessageUpdate();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
    this.updatePillowColorOption();
    this.updateDynamicVariantNameTxt();
  }

  updateGlobalColorLabel() {
    const currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    if (currentVariant) {
      let productElement = this.closest('.product');
      let globalColourLabels = productElement.querySelectorAll(".BBB-UPSELL-option-with-colors-footer-txt");

      globalColourLabels.forEach((label)=>{
        label.querySelector("span").innerText = currentVariant.option1;
      })
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    // if (!this.currentVariant) return;
    // if (!this.currentVariant.featured_media) return;

    // AB-TEST:bpm-gallery-v1 — the pillow gallery is the deterministic block gallery
    // (ab-bpm-gallery-v1.liquid owns slide activation). Its per-block data-media-ids
    // don't match `${section}-${featured_media.id}`, so the theme's setActiveMedia call
    // here threw and aborted the rest of onVariantChange (button stayed disabled, URL not
    // updated). Skip it for the pillow.
    const _bpmGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (_bpmGallery && _bpmGallery.hasAttribute('data-bpm-variant')) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);

    const fieldsets = Array.from(this.querySelectorAll('fieldset'));

    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);

    if(this.options.length == 0){
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
      
    this.currentVariantDetails = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    
    if(mediaGallery.dataset.currentVariantFromStart == 'true'){
      mediaGallery.scrollToSlide(`${this.dataset.section}-${this.currentVariantDetails.featured_media.id}`);
      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariantDetails.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }else{
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }
    
  }

  pillowColorOption(){
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
      
    this.currentVariantDetails = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    let colorDropdownOptions = this.closest('.product').querySelectorAll('[name="options[Color]"] option');
    
    let upsellProductOptions = this.closest('.product').querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option:nth-of-type(n+2)');
    if(this.closest('.product').classList.contains('upsell-buttons_with_colors')){
      upsellProductOptions = this.closest('.product').querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option-with-colors:nth-of-type(n+2)');
    }

    upsellProductOptions.forEach((upsellOption)=>{
      let upsellVarientsInfo = JSON.parse(upsellOption.getAttribute('data-product-info'));
      let selectedUpsellVariant = upsellVarientsInfo[0];

      upsellVarientsInfo.forEach((upsellVariant, index)=>{
        if(upsellVariant.title == this.currentVariantDetails.title){
          selectedUpsellVariant = upsellVariant;
        }
      })

      if(upsellVarientsInfo.length > 1){
        pillowColorOptionHandle(upsellVarientsInfo, selectedUpsellVariant, upsellVarientsInfo, upsellOption.getAttribute('data-product-id'), true, this);
      }

      // console.log(upsellVarientsInfo, colorDropdownOptions, this.currentVariantDetails, this.getVariantData());
    })

    if(colorDropdownOptions.length != 0 && this.getVariantData()){
      pillowColorOptionHandle(colorDropdownOptions, this.currentVariantDetails, this.getVariantData(), '', false, this);
    }

    // set upsell class if bundle variant
    if(document.querySelector('.product').classList.contains('upsell-tabs')){
      let customUpsellTabs = document.querySelectorAll('.UPSELL-tabs-section .UPSELL-tabs-btn');
      let customVaraintUpsellTabs = document.querySelectorAll('.UPSELL-tabs-section .UPSELL-tabs-btn.variant-option');
      let customUpsellTabsContent = document.querySelectorAll('.UPSELL-tabs-section .UPSELL-tabs-content');
      let customVaraintUpsellTabsContent = document.querySelectorAll('.UPSELL-tabs-section .UPSELL-tabs-content.variant-option');
      
      if(customVaraintUpsellTabs && customVaraintUpsellTabs.length > 0){
        customUpsellTabs.forEach((option)=>{
          option.classList.remove('UPSELL-tabs-btn-selected');
        })
        customVaraintUpsellTabs.forEach((option)=>{
          if(this.currentVariantDetails.option2){
            if(option.getAttribute('data-bundle-variant-title') == this.currentVariantDetails.option2){
              option.classList.add('UPSELL-tabs-btn-selected');
            }
          }else{
            if(option.getAttribute('data-bundle-variant-title') == this.currentVariantDetails.option1){
              option.classList.add('UPSELL-tabs-btn-selected');
            }
          }
        })
      }

      if(customVaraintUpsellTabsContent && customVaraintUpsellTabsContent.length > 0){
        customUpsellTabsContent.forEach((option)=>{
          option.classList.remove('UPSELL-tabs-content-selected');
        })
        customVaraintUpsellTabsContent.forEach((option)=>{
          if(this.currentVariantDetails.option2){
            if(option.getAttribute('data-bundle-variant-title') == this.currentVariantDetails.option2){
              option.classList.add('UPSELL-tabs-content-selected');
            }
          }else{
            if(option.getAttribute('data-bundle-variant-title') == this.currentVariantDetails.option1){
              option.classList.add('UPSELL-tabs-content-selected');
            }
          }
        })
      }
    }else{
      let customUpsellOptions = document.querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option');
      let customVaraintUpsellOptions = document.querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option.variant-option');

      if(this.closest('.product').classList.contains('upsell-buttons_with_colors')){
        customUpsellOptions = document.querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option-with-colors');
        customVaraintUpsellOptions = document.querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option-with-colors.variant-option');
      }
      
      if(customVaraintUpsellOptions && customVaraintUpsellOptions.length > 0){
        customUpsellOptions.forEach((option)=>{
          option.classList.remove('BBB-UPSELL-selected');
        })
        customVaraintUpsellOptions.forEach((option)=>{
          if(this.currentVariantDetails.option2){
            if(option.getAttribute('data-bundle-variant-title') == this.currentVariantDetails.option2){
              option.classList.add('BBB-UPSELL-selected');
            }
          }else{
            if(option.getAttribute('data-bundle-variant-title') == this.currentVariantDetails.option1){
              option.classList.add('BBB-UPSELL-selected');
            }
          }
        })
      }
    }
    // set upsell class if bundle variant
  }

  pillowColorImageChange(){
    // AB-TEST:bpm-gallery-v1 — the pillow uses the deterministic block gallery; its
    // <media-gallery> carries data-bpm-variant. Skip this rebuild so the server-rendered
    // blocks are never stripped; ab-bpm-gallery-v1.liquid owns the switch via CSS instead.
    let _bpmProduct = this.closest('.product');
    if(_bpmProduct && _bpmProduct.querySelector('media-gallery[data-bpm-variant]')){ return; }
    let applicableTemplates = ['bmp-colors', 'combo-colors', 'cover-colors', 'pillow2_new_copy', 'pillow2_new_copy_v2', 'pillow2_new_badges_all', 'pillow2_new_copy_test', 'fba-colors', 'nausea-relief', 'nausea-relief-2', 'nausea-relief-3', 'bundle2', 'leggings-post-pregnancy-2', 'ppl-color'];

    let productElement = this.closest('.product');
    let featureProductClass = ['featured-product', 'show_custom_variant_swatches', 'product--thumbnail_slider'];
    let isFeaturedProduct = featureProductClass.every(cls => productElement.classList.contains(cls));

    let currentProductIndex = 0;
    document.querySelectorAll('.product').forEach((el, index)=>{
      if(el == productElement){
        currentProductIndex = index;
      }
    })

    let mediaGalleryViews, mediaGalleryThumbs, fixedViewsImages, fixedThumbImages;
    if(currentProductIndex == 0){
      mediaGalleryViews = mediaGalleryViews1;
      mediaGalleryThumbs = mediaGalleryThumbs1;
      fixedViewsImages = fixedViewsImages1;
      fixedThumbImages = fixedThumbImages1;
    }else if(currentProductIndex == 1){
      if(mediaGalleryViewsWrapper.length == 1){
        mediaGalleryViews = mediaGalleryViews1;
        mediaGalleryThumbs = mediaGalleryThumbs1;
        fixedViewsImages = fixedViewsImages1;
        fixedThumbImages = fixedThumbImages1;

        currentProductIndex = 0;
      }else{
        mediaGalleryViews = mediaGalleryViews2;
        mediaGalleryThumbs = mediaGalleryThumbs2;
        fixedViewsImages = fixedViewsImages2;
        fixedThumbImages = fixedThumbImages2;
      }
    }
    
    let mediaGalleryMain = productElement.querySelector(`#MediaGallery-${this.dataset.section}`);
    
    if(applicableTemplates.indexOf(window._template.suffix) != -1 || isFeaturedProduct){
      if(this.getVariantData()){
        // code

        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);

        if(this.options.length == 0){
          this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
          });
        }
    
        this.currentVariantDetails = this.getVariantData().find((variant) => {
          return !variant.options.map((option, index) => {
            return this.options[index] === option;
          }).includes(false);
        });
        
        if(this.currentVariantDetails.featured_media?.alt != null){

          // set image of index 2 and 3
          let indicesToRemove = [];
          let updatedMediaGalleryViews = Array.from(mediaGalleryViews);
          let updatedMediaGalleryThumbs = Array.from(mediaGalleryThumbs);

          let currentVariantPos = 0;
          if(!fixedViewsImages[0]){
            this.getVariantData().forEach((variant,index)=>{
              if(this.currentVariantDetails.id == variant.id){
                if(index > 0){
                  currentVariantPos = 1;
                }
              }
            })
          }

          let getAllVariantTitleData = [];

          this.getVariantData().forEach((data) => {
            // Split title by '/' if present, else use the original title
            const titles = data.title.includes('/') 
              ? data.title.split('/') 
              : [data.title];
          
            titles.forEach((titlePart) => {
              const cleaned = titlePart.toLowerCase()
                .replace(/™/g, '')
                .replace(/'/g, '')
                .replace(/[^\w\s]/g, '')
                .trim()
                .replace(/\s+/g, '_');
          
              getAllVariantTitleData.push(cleaned);
            });
          });
          
          getAllVariantTitleData = [...new Set(getAllVariantTitleData)]; // remove duplicates

          // console.log(getAllVariantTitleData);
          
          mediaGalleryViews.forEach((mediaGalleryView, index)=>{
            if(getAllVariantTitleData.every(title => mediaGalleryView.querySelector(`.product__media img`).getAttribute('alt').indexOf(title.toLowerCase()) !== -1)){
              let fixedViewsImageObj = {
                id: (index - currentVariantPos),
                el: mediaGalleryView
              }
              fixedViewsImages.push(fixedViewsImageObj);
              indicesToRemove.push(index);
            }
          })

          mediaGalleryThumbs.forEach((mediaGalleryThumb, index)=>{
            if(getAllVariantTitleData.every(title => mediaGalleryThumb.querySelector(`.thumbnail img`).getAttribute('alt').indexOf(title.toLowerCase()) !== -1)){
              let fixedThumbImageObj = {
                id: (index - currentVariantPos),
                el: mediaGalleryThumb
              }
              fixedThumbImages.push(fixedThumbImageObj);
            }
          })
          
          indicesToRemove.sort((a, b) => b - a);
          for (const index of indicesToRemove) {
            if (index >= 0 && index < updatedMediaGalleryViews.length) {
              updatedMediaGalleryViews.splice(index, 1);
            }
            if (index >= 0 && index < updatedMediaGalleryThumbs.length) {
              updatedMediaGalleryThumbs.splice(index, 1);
            }
          }
          // set image of index 2 and 3

          let mediaIsSet = false;

          let colorDropdownOptions = productElement.querySelectorAll('[name="options[Color]"] option');
          let currentVariantTitleArr = [];
          
          colorDropdownOptions.forEach((option)=>{
            let optionValue = option.value;
            // if multiple variables present
            if(this.currentVariantDetails.title.indexOf(optionValue) !== -1){
              currentVariantTitleArr.push(`color_${optionValue.toLowerCase()}`);
            }
          });

          let allVariantTitleArr = [...productElement.querySelectorAll('.product-form__input select')]
          .filter(s => s.name !== 'options[Color]')
          .filter(s => s.name !== 'options[Options]')
          .filter(s => s.name !== 'options[Size]')
          .filter(s => s.name !== 'options[Leggings Size]')
          .map(s => s.value
            .toLowerCase()
            .replace(/™/g, '')
            .replace(/'/g, '')
            .replace(/[^\w\s]/g, '') // remove other special characters
            .trim()
            .replace(/\s+/g, '_')
          );

          let allVariantTitleArrRADIO = [...productElement.querySelectorAll('.product-form__input [type="radio"]:checked')]
          .filter(s => ['Flavor', 'Size', 'Pack'].includes(s.name)) // example: only certain variant groups
          .map(s => s.value
            .toLowerCase()
            .replace(/™/g, '')
            .replace(/'/g, '')
            .replace(/[^\w\s]/g, '')
            .trim()
            .replace(/\s+/g, '_')
          );
                
          if(allVariantTitleArr.length > 0){
            allVariantTitleArr.forEach((title)=>{
              currentVariantTitleArr.push(title);
            })
          }

          if(allVariantTitleArrRADIO.length > 0){
            allVariantTitleArrRADIO.forEach((title)=>{
              currentVariantTitleArr.push(title);
            })
          }
          
          localStorage.setItem('selected_variant_title', currentVariantTitleArr);
          console.log('selected_variant_title', currentVariantTitleArr);

          mediaGalleryMain.querySelectorAll(`#Slider-Thumbnails-${this.dataset.section} li`).forEach((mediaGalleryThumb)=>{
            mediaGalleryThumb.remove();
          })
          
          updatedMediaGalleryThumbs.forEach((mediaGalleryThumb, index)=>{
            let imgAlt = mediaGalleryThumb.querySelector(`.thumbnail img`).getAttribute('alt');
            if(currentVariantTitleArr.every(v => imgAlt.includes(`#${v}`))){
              // console.log(mediaGalleryThumbsWrapper, mediaGalleryThumb);
              mediaGalleryThumbsWrapper[currentProductIndex].append(mediaGalleryThumb);
              mediaGalleryThumbsWrapper[currentProductIndex].dispatchEvent(new Event('resize'));
            }
          });

          mediaGalleryMain.querySelectorAll(`#Slider-Gallery-${this.dataset.section} li`).forEach((mediaGalleryView)=>{
            mediaGalleryView.remove();
          })
          
          updatedMediaGalleryViews.forEach((mediaGalleryView, index)=>{
            let imgAlt = mediaGalleryView.querySelector(`.product__media img`).getAttribute('alt');
            if(currentVariantTitleArr.every(v => imgAlt.includes(`#${v}`))){
              mediaGalleryViewsWrapper[currentProductIndex].append(mediaGalleryView);
              if(!mediaIsSet){
                if(mediaGalleryMain.dataset.currentVariantFromStart == 'true'){
                  mediaGalleryMain.setActiveMedia(mediaGalleryView.dataset.mediaId, false);
                }else{
                  mediaGalleryMain.setActiveMedia(mediaGalleryView.dataset.mediaId, true);
                }
                mediaIsSet = true;
              }
            }
          });
          mediaGalleryMain.dataset.activeSlide = "1";
          
          // set image of index 2 and 3
          fixedViewsImages.forEach((fixImg)=>{
            productElement.querySelector(`.product__media-list.slider`).insertBefore(fixImg.el, productElement.querySelectorAll(`.product__media-list.slider li`)[fixImg.id]);
          })
          fixedThumbImages.forEach((fixThumb)=>{
            productElement.querySelector(`.thumbnail-list.slider`).insertBefore(fixThumb.el, productElement.querySelectorAll(`.thumbnail-list.slider li`)[fixThumb.id]);
          })
          // set image of index 2 and 3

          let updatedMediaGalleryThumbs2 = productElement.querySelectorAll(`.thumbnail-list.slider li`);
          let thumbIndex = 1;
          updatedMediaGalleryThumbs2.forEach((mediaGalleryThumb)=>{
            mediaGalleryThumb.setAttribute('data-media-position', thumbIndex);
            thumbIndex++;
          });

          let newSliderComponents = productElement.querySelectorAll('slider-component');
          newSliderComponents.forEach((newSliderComponent)=>{
            newSliderComponent.resetPages();
            // newSliderComponent.update();
          })
          let mediaGalleryPagination = productElement.querySelectorAll(`.slider-pagination .slider-pagination-link`);

          mediaGalleryPagination.forEach((pagination, index)=>{
            pagination.classList.add('pagination-hidden');
            if((index+1) <= (thumbIndex-1)){
              pagination.classList.remove('pagination-hidden');
            }
          })

          // dynamic image set
          let dynamicImages = document.querySelectorAll('[data-product-image-index]');
          dynamicImages.forEach((img)=>{
            let imgDynamicIndex = Number(img.dataset.productImageIndex) - 1;
            img.setAttribute('srcset', productElement.querySelectorAll(`.product__media-list.slider li`)[imgDynamicIndex].querySelector('img').getAttribute('srcset'));
            img.setAttribute('src', productElement.querySelectorAll(`.product__media-list.slider li`)[imgDynamicIndex].querySelector('img').getAttribute('src'));
          })
          // dynamic image set

          // upsell thumbnail set

          let upsellProductOptions;
          if(productElement.classList.contains('upsell-tabs')){
            upsellProductOptions = productElement.querySelectorAll('.UPSELL-tabs-section .UPSELL-tabs-content');
          }if(productElement.classList.contains('upsell-buttons_with_colors')){
            upsellProductOptions = productElement.querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option-with-colors');
          }else{
            upsellProductOptions = productElement.querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option');
          }

          const matchesExactTags = (alt, targetTags) => {
            const altTags = alt.match(/#\w+/g) || [];
            
            const cleanedAltTags = altTags.map(t => t.replace('#', '')).sort();
            const cleanedTargetTags = [...targetTags].sort();
            
            return (
              cleanedAltTags.length === cleanedTargetTags.length &&
              cleanedAltTags.every((tag, i) => tag === cleanedTargetTags[i])
            );
          };

          // console.log(this.getVariantData());
          let upsellVariantTitleArr = currentVariantTitleArr;

          if(upsellProductOptions.length){
            upsellProductOptions.forEach((upsellOption)=>{
              let isThumbnailSet = false;
              let newProductGalleryImages = JSON.parse(upsellOption.dataset.images);

              let upsellVariantTypes = JSON.parse(upsellOption.getAttribute('data-variant-type'));

              if(upsellOption.classList.contains('variant-option')){
                upsellVariantTitleArr[1] = upsellOption.getAttribute('data-bundle-variant-title').toLowerCase()
                  .replace(/™/g, '')
                  .replace(/'/g, '')
                  .replace(/[^\w\s]/g, '') // remove other special characters
                  .trim()
                  .replace(/\s+/g, '_');
                
              }else{
                if(productElement.classList.contains('upsell-buttons_with_colors')){
                  upsellVariantTitleArr[1] = upsellOption.querySelector('.BBB-UPSELL-option-with-colors-title').textContent.toLowerCase()
                    .replace(/™/g, '')
                    .replace(/'/g, '')
                    .replace(/[^\w\s]/g, '') // remove other special characters
                    .trim()
                    .replace(/\s+/g, '_');
                }else{
                  upsellVariantTitleArr[1] = upsellOption.querySelector('.BBB-UPSELL-option-title').textContent.toLowerCase()
                    .replace(/™/g, '')
                    .replace(/'/g, '')
                    .replace(/[^\w\s]/g, '') // remove other special characters
                    .trim()
                    .replace(/\s+/g, '_');
                }
              }
  
              newProductGalleryImages.forEach((data)=>{
                if (matchesExactTags(data.alt, upsellVariantTitleArr)) {
                  if(!isThumbnailSet){
                    upsellOption.querySelector('img').src = data.src;
                    upsellOption.querySelector('img').srcset = data.src;
                    isThumbnailSet = true;
                  }
                }
              })
              
            })
          }
          // upsell thumbnail set
          
        }

        // mediaGalleryMain.classList.remove('gallery-is-loading');
        // code
      }
    }
  }

  updatePillowColorOption(){
    this.currentVariantDetails = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    
    let customColorOptions = document.querySelectorAll('.bbb-pillow-product-form__colors-options button');
    if(customColorOptions && customColorOptions.length > 0){
      customColorOptions.forEach((option)=>{
        option.classList.remove('bbb-pillow-selected');
      })

      customColorOptions.forEach((option)=>{
        if (this.currentVariantDetails.title.indexOf(option.dataset.color) != -1){
          option.classList.add('bbb-pillow-selected');
        }
      })
    }

    // set upsell class if bundle variant
    let customUpsellOptions = document.querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option');
    let customVaraintUpsellOptions = document.querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option.variant-option');

    if(this.closest('.product').classList.contains('upsell-buttons_with_colors')){
      customUpsellOptions = document.querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option-with-colors');
      customVaraintUpsellOptions = document.querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option-with-colors.variant-option');
    }
    
    if(customVaraintUpsellOptions && customVaraintUpsellOptions.length > 0){
      customUpsellOptions.forEach((option)=>{
        option.classList.remove('BBB-UPSELL-selected');
      })
      customVaraintUpsellOptions.forEach((option)=>{
        if(option.getAttribute('data-bundle-variant-title') == this.currentVariantDetails.option2){
          option.classList.add('BBB-UPSELL-selected');
        }
      })
    }
    // set upsell class if bundle variant

    customUpsellOptions = document.querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option');
    let prevSelectedUpsellOption = document.querySelector('.BBB-UPSELL-options-section .BBB-UPSELL-option.BBB-UPSELL-selected');

    if(this.closest('.product').classList.contains('upsell-buttons_with_colors')){
      customUpsellOptions = document.querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option-with-colors');
      prevSelectedUpsellOption = document.querySelector('.BBB-UPSELL-options-section .BBB-UPSELL-option-with-colors.BBB-UPSELL-selected');
    }
    
    if(prevSelectedUpsellOption && !prevSelectedUpsellOption.classList.contains('variant-option')){
      if(customUpsellOptions && customUpsellOptions.length > 0){
        customUpsellOptions.forEach((option)=>{
          option.classList.remove('BBB-UPSELL-selected');
        })
        customUpsellOptions.forEach((option)=>{
          if (option.classList.contains('BBB-UPSELL-current-option')){ option.classList.add('BBB-UPSELL-selected')};
        })
      }
    }
  }

  updateDynamicVariantNameTxt(){
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));

    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);

    if(this.options.length == 0){
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }

    this.currentVariantDetails = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    document.querySelectorAll('.js-dynamic-label').forEach((legend) => {
      var idx   = legend.dataset.optIndex; // "1", "2", ...
      var curr  = (this.currentVariantDetails['option' + idx] || '').trim();

      // turn data-map into an object
      var mapObj = {};
      try {
        mapObj = JSON.parse(legend.dataset.map || '{}');
      } catch(e) {}

      // choose label: override if exact match, otherwise fallback default
      var finalLabel = mapObj[curr] || legend.dataset.default || '';

      // render
      if (legend.dataset.hasName === 'true') {
        var bits = finalLabel.split(':name');
        legend.innerHTML =
          (bits[0] || '') +
          '<span class="dynamic_variant_name">' + curr + '</span>' +
          (bits[1] || '');
      } else {
        legend.textContent = finalLabel;
      }
    });

  }

  shopPayMessageUpdate(){
    var isShopPayShadow = false;
    var editedOnce = false;
    var editInterval = 400;

    var shopPayWrapperAll = document.querySelectorAll('shopify-payment-terms');
    if(window.Shopify.currency.active == 'USD'){
      shopPayWrapperAll.forEach((shopPayWrapper) => {
        
        if(shopPayWrapper && shopPayWrapper.shadowRoot && shopPayWrapper.style.display != 'none'){
          if(shopPayWrapper.classList.contains('message-edited')){
            editInterval = 100;
          }
          
          shopPayWrapper.style.visibility = 'hidden';
    
          this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
      
          this.currentVariantDetails = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
              return this.options[index] === option;
            }).includes(false);
          });
      
          // BUGFIX (24 Jul 2026) — Shop Pay installments vanished on variant change.
          // The banner is hidden here and only ever un-hidden inside the branch below.
          // That branch used to require `priceEl` (#price-<section>), but products whose
          // pricing is rendered by an app instead of the theme price block — e.g.
          // /products/bph2, priced by Kaching Bundles — have no #price-<section> element
          // at all, so the banner stayed `visibility:hidden` forever (and the polling
          // interval was never cleared). The banner price comes from the variant JSON
          // below; priceEl is only needed for the test_19 price experiment, so it is now
          // optional and every exit path restores visibility.
          var priceEl = document.getElementById(`price-${this.dataset.section}`);
          if(!this.currentVariantDetails){
            shopPayWrapper.style.visibility = 'visible';
            return;
          }
          var productPriceMainBefore = this.currentVariantDetails.price;
          var hasOtherVariants = false;
          if(this.currentVariantDetails.options.length > 1){
            hasOtherVariants = true;
          }

          // Failsafe: whatever happens below, never leave the banner invisible.
          var shopPayFailsafe = setTimeout(function(){
            clearInterval(shopPayInterval);
            shopPayWrapper.style.visibility = 'visible';
          }, 3000);

          function shopPayHandle(){
            var shopPayTermsShadow = shopPayWrapper.shadowRoot;
            if(shopPayTermsShadow != null){
              isShopPayShadow = true;
              setTimeout(()=>{
                clearInterval(shopPayInterval);
              }, 1500)
              
              var productPriceMain = priceEl ? priceEl.dataset.price : null;
              if(hasOtherVariants){
                productPriceMain = productPriceMainBefore;
              }
              productPriceMain = productPriceMainBefore;

              if(priceEl && window.test_19_variation_0 == true){
                productPriceMain = Number(priceEl.querySelector('.price.test_id_19_price_var_0')?.getAttribute('data-test-19-price-control'));
              } else if(priceEl && window.test_19_variation_1 == true){
                productPriceMain = Number(priceEl.querySelector('.price.test_id_19_price_var_1')?.getAttribute('data-test-19-price-control'));
              } else if(priceEl && window.test_19_variation_2 == true){
                productPriceMain = Number(priceEl.querySelector('.price.test_id_19_price_var_2')?.getAttribute('data-test-19-price-control'));
              }
              
              if(productPriceMain == null || productPriceMain == 0 || productPriceMain == '' || isNaN(productPriceMain)){
                productPriceMain = productPriceMainBefore;
              }
              
              // On PDPs with Kaching Bundles the shopper pays the bundle total, not the
              // unit price — quote the installment off that so the banner matches checkout.
              var kachingTotalCents = getKachingBundleTotalCents();
              if(kachingTotalCents){
                productPriceMain = kachingTotalCents;
              }

              var productPrice = productPriceMain/100;
              var priceCurrency = new Intl.NumberFormat("en", { style: "currency", currency: window.Shopify.currency.active }).formatToParts(0).find((part) => part.type === "currency").value;
              var product4thPrice = productPrice/4;
              product4thPrice = Math.floor(product4thPrice*100)/100;
              product4thPrice = priceCurrency + product4thPrice
              //var shopPayUpdatedTxt = `or 4 interest-free installments of ${product4thPrice} with`;
              
              var shopPayBanner = shopPayTermsShadow.querySelector('#shopify-installments');
              var shopPayInstContent = shopPayBanner ? shopPayBanner.querySelector('#shopify-installments-content') : null;
              var shopPayInstCTA = shopPayBanner ? shopPayBanner.querySelector('#shopify-installments-cta') : null;
              var isStyle1 = shopPayWrapper.closest('.product') != null && shopPayWrapper.closest('.product').classList.contains('template-style_1');

              // Shopify owns the markup inside the banner — if it ever changes shape, show
              // the stock banner rather than leaving a hidden element behind.
              if(!shopPayInstContent){
                clearTimeout(shopPayFailsafe);
                clearInterval(shopPayInterval);
                shopPayWrapper.style.visibility = 'visible';
                return;
              }

              // update shop pay inner copy
              if(shopPayInstContent.querySelector('b') != null){
                shopPayInstContent.querySelector('b').innerHTML = product4thPrice;
              }
              if(shopPayInstContent.querySelector('.font-bold') != null){
                shopPayInstContent.querySelector('.font-bold').innerHTML = product4thPrice;
              }

              if(isStyle1){
                if(shopPayInstContent.querySelector('b') != null){
                  shopPayInstContent.querySelector('b').style.fontWeight = '400';
                }
                if(shopPayInstContent.querySelector('.font-bold') != null){
                  shopPayInstContent.querySelector('.font-bold').style.fontWeight = '400';
                }
                shopPayInstContent.style.fontSize = '14px';
                shopPayInstContent.style.lineHeight = '1.428';
                shopPayInstContent.style.letterSpacing = '0';
                shopPayInstContent.style.color = '#55526D';
                shopPayInstContent.style.paddingRight = '3px';

                if(shopPayInstCTA){
                  shopPayInstCTA.style.fontSize = '14px';
                  shopPayInstCTA.style.fontWeight = '700';
                  shopPayInstCTA.style.lineHeight = '1.428';
                  shopPayInstContent.style.letterSpacing = '0';
                  shopPayInstCTA.style.textUnderlineOffset = '2px';
                  shopPayInstCTA.style.color = '#EA5F54';
                }

                if(shopPayInstContent.querySelector('svg') != null){
                  shopPayInstContent.querySelector('svg').style.display = 'none';
                }
              }
      
              var nodeCount = 0;
              for (const shopPayNode of shopPayInstContent.childNodes) {
                if (shopPayNode.nodeType === Node.TEXT_NODE) {
                  nodeCount++;
                  if(nodeCount == 1){
                    if(isStyle1){
                      shopPayNode.textContent = `Pay in 4 installments of `;
                    }else{
                      shopPayNode.textContent = `Pay in 4 interest-free installments of `;
                    }
                  }else if(nodeCount == 2){
                    if(isStyle1){
                      shopPayNode.textContent = ` with ShopPay.`;
                    }else{
                      shopPayNode.textContent = ` with `;
                    }
                  }else{
                    shopPayNode.textContent = ``;
                  }
                  shopPayWrapper.classList.add('message-edited');
                  //console.log(shopPayNode.textContent);
                }
              }
              // update shop pay inner copy

              clearTimeout(shopPayFailsafe);
              shopPayWrapper.style.visibility = 'visible';
            }else{
              shopPayWrapper = document.querySelector('shopify-payment-terms');
            }
          }
    
          var shopPayInterval = setInterval(()=>{
            shopPayHandle();
          }, editInterval)
          
        }
      })
    }
  }

  hideOtherMedia(){

    let productElement = this.closest('.product');
    let mediaGalleryMain = productElement.querySelector(`#MediaGallery-${this.dataset.section}`);
    
    if(mediaGalleryMain.dataset.hideOtherVariant == 'true'){
      if(this.getVariantData()){
        mediaGalleryMain.dataset.activeSlide = "1";
    
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    
        this.currentVariantDetails = this.getVariantData().find((variant) => {
          return !variant.options.map((option, index) => {
            return this.options[index] === option;
          }).includes(false);
        });
        if(this.currentVariantDetails.featured_media != null && this.currentVariantDetails.featured_media.alt != null){
          
          let variantTypeAll = Array.from(this.querySelectorAll('select'), (select) => select.getAttribute('name'));
          let variantType = variantTypeAll[0];
          variantType = variantType.replace('options[', '');
          variantType = variantType.replace(']', '');
          variantType = variantType.toLowerCase();
      
          let currentVariantTitle;
      
          if(this.currentVariantDetails.option1.indexOf('BLISSFUL') != -1 && this.currentVariantDetails.option1.indexOf('BUNDLE') != -1){
            currentVariantTitle = 'BLISSFUL BUNDLE';
          }else{
            currentVariantTitle = this.currentVariantDetails.option1;
          }
      
          currentVariantTitle = currentVariantTitle.normalize('NFKD')
                                    .replace(/[\u0300-\u036f]/g, '')
                                    .trim()
                                    .toLowerCase()
                                    .replace(/[^a-z0-9 -]/g, '')
                                    .replace(/\s+/g, '-')
                                    .replace(/-+/g, '-');
          
          currentVariantTitle = `${variantType}_${currentVariantTitle}`;

          let colorDropdownOptions = productElement.querySelectorAll('[name="options[Color]"] option');
          let currentVariantTitleArr = [];
          
          colorDropdownOptions.forEach((option)=>{
            let optionValue = option.value;
            // if multiple variables present
            if(this.currentVariantDetails.title.indexOf(optionValue) !== -1){
              currentVariantTitleArr.push(`color_${optionValue.toLowerCase()}`);
            }
          });

          let allVariantTitleArr = [...productElement.querySelectorAll('.product-form__input select')]
          .filter(s => s.name !== 'options[Color]')
          .filter(s => s.name !== 'options[Options]')
          .filter(s => s.name !== 'options[Size]')
          .map(s => s.value
            .toLowerCase()
            .replace(/™/g, '')
            .replace(/'/g, '')
            .replace(/[^\w\s]/g, '') // remove other special characters
            .trim()
            .replace(/\s+/g, '_')
          );
                
          if(allVariantTitleArr.length > 0){
            allVariantTitleArr.forEach((title)=>{
              currentVariantTitleArr.push(title);
            })
          }
          
          let mediaGalleryViews = mediaGalleryMain.querySelectorAll(`#Slider-Gallery-${this.dataset.section} li`);
          let mediaGalleryThumbs = mediaGalleryMain.querySelectorAll(`#Slider-Thumbnails-${this.dataset.section} li`);
          let mediaGalleryPagination = mediaGalleryMain.querySelectorAll(`.slider-pagination .slider-pagination-link`);
      
          let mediaIsSet = false;
      
          mediaGalleryViews.forEach((mediaGalleryView)=>{
            let imgAlt = mediaGalleryView.querySelector(`.product__media img`).getAttribute('alt');
            // if(imgAlt.indexOf(currentVariantTitle) == -1){
            //   mediaGalleryView.classList.add('custom-option_hidden');
            // }else{
            //   mediaGalleryView.classList.remove('custom-option_hidden');
            //   if(!mediaIsSet){
            //     mediaGalleryMain.setActiveMedia(mediaGalleryView.dataset.mediaId, true);
            //     mediaIsSet = true;
            //   }
            // }
            if(currentVariantTitleArr.every(v => imgAlt.includes(`#${v}`))){
              mediaGalleryView.classList.remove('custom-option_hidden');
              if(!mediaIsSet){
                console.log('worked');
                // mediaGalleryMain.setActiveMedia(mediaGalleryView.dataset.mediaId, true);
                if(mediaGalleryMain.dataset.currentVariantFromStart == 'true'){
                  mediaGalleryMain.scrollToSlide(`${this.dataset.section}-${this.currentVariantDetails.featured_media.id}`);
                  const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
                  const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariantDetails.featured_media.id}"]`);
                  modalContent.prepend(newMediaModal);
                }else{
                  mediaGalleryMain.setActiveMedia(mediaGalleryView.dataset.mediaId, true);
                }
                mediaIsSet = true;
              }
            }else{
              mediaGalleryView.classList.add('custom-option_hidden');
            }
          });
    
          let thumbIndex = 1;
          mediaGalleryThumbs.forEach((mediaGalleryThumb, index)=>{
            let imgAlt = mediaGalleryThumb.querySelector(`.thumbnail img`).getAttribute('alt');
            // if(imgAlt.indexOf(currentVariantTitle) == -1){
            //   mediaGalleryThumb.classList.add('custom-option_hidden');
            // }else{
            //   mediaGalleryThumb.classList.remove('custom-option_hidden');
            //   mediaGalleryThumb.dataset.mediaPosition = thumbIndex;
            //   thumbIndex++;
            // }
            if(currentVariantTitleArr.every(v => imgAlt.includes(`#${v}`))){
              mediaGalleryThumb.classList.remove('custom-option_hidden');
              mediaGalleryThumb.dataset.mediaPosition = thumbIndex;
              thumbIndex++;
            }else{
              mediaGalleryThumb.classList.add('custom-option_hidden');
            }
          });
    
          // pagination handle
          mediaGalleryPagination.forEach((pagination, index)=>{
            pagination.classList.add('pagination-hidden');
            if((index+1) <= (thumbIndex-1)){
              pagination.classList.remove('pagination-hidden');
            }
          })
        }
        mediaGalleryMain.classList.remove('gallery-is-loading');
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    let customUpsellOptions = document.querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option');

    if(this.closest('.product').classList.contains('upsell-buttons_with_colors')){
      customUpsellOptions = document.querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option-with-colors');
    }

    customUpsellOptions.forEach((option)=>{
      option.style.pointerEvents = "none";
      option.style.opacity = 0.8;
    })
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const destinations = document.querySelectorAll(`#${id}`); // for the multiple price instances
        const source = html.getElementById(id);
        
         // for the multiple price instances
        destinations.forEach((destination_el)=>{
          if (source && destination_el) destination_el.innerHTML = source.innerHTML;
        })
         // for the multiple price instances
         
        // if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        if (
          !this.dataset.url.includes("/products/ice-cool-bubs-extra-pillow-covers") &&
          !this.dataset.url.includes("/products/bubs-extra-pillow-covers-copy") &&
          !this.dataset.url.includes("/products/nursingpillow") &&
          !this.dataset.url.includes("/products/bubs-pregnancy-hydration-nausea-relief") &&
          !this.dataset.url.includes("/products/bph")
        ) {
          if(this.currentVariant.options.length == 1){
            updateTestPrice(price);
          }
        }

        customUpsellOptions = document.querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option');

        if(this.closest('.product').classList.contains('upsell-buttons_with_colors')){
          customUpsellOptions = document.querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option-with-colors');
        }

        customUpsellOptions.forEach((option)=>{
          option.style.pointerEvents = "auto";
          option.style.opacity = 1;
        })
        
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  shopPayMessageUpdate(){
    var isShopPayShadow = false;
    var editedOnce = false;
    var editInterval = 400;

    var shopPayWrapperAll = document.querySelectorAll('shopify-payment-terms');
    if(window.Shopify.currency.active == 'USD'){
      shopPayWrapperAll.forEach((shopPayWrapper) => {
        
        if(shopPayWrapper && shopPayWrapper.shadowRoot && shopPayWrapper.style.display != 'none'){
          if(shopPayWrapper.classList.contains('message-edited')){
            editInterval = 100;
          }
          
          shopPayWrapper.style.visibility = 'hidden';
    
          const fieldsets = Array.from(this.querySelectorAll('fieldset'));
          this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
          });
      
          this.currentVariantDetails = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
              return this.options[index] === option;
            }).includes(false);
          });
      
          // BUGFIX (24 Jul 2026) — Shop Pay installments vanished on variant change.
          // The banner is hidden here and only ever un-hidden inside the branch below.
          // That branch used to require `priceEl` (#price-<section>), but products whose
          // pricing is rendered by an app instead of the theme price block — e.g.
          // /products/bph2, priced by Kaching Bundles — have no #price-<section> element
          // at all, so the banner stayed `visibility:hidden` forever (and the polling
          // interval was never cleared). The banner price comes from the variant JSON
          // below; priceEl is only needed for the test_19 price experiment, so it is now
          // optional and every exit path restores visibility.
          var priceEl = document.getElementById(`price-${this.dataset.section}`);
          if(!this.currentVariantDetails){
            shopPayWrapper.style.visibility = 'visible';
            return;
          }
          var productPriceMainBefore = this.currentVariantDetails.price;
          var hasOtherVariants = false;
          if(this.currentVariantDetails.options.length > 1){
            hasOtherVariants = true;
          }

          // Failsafe: whatever happens below, never leave the banner invisible.
          var shopPayFailsafe = setTimeout(function(){
            clearInterval(shopPayInterval);
            shopPayWrapper.style.visibility = 'visible';
          }, 3000);

          function shopPayHandle(){
            var shopPayTermsShadow = shopPayWrapper.shadowRoot;
            if(shopPayTermsShadow != null){
              isShopPayShadow = true;
              setTimeout(()=>{
                clearInterval(shopPayInterval);
              }, 1500)
              
              var productPriceMain = priceEl ? priceEl.dataset.price : null;
              if(hasOtherVariants){
                productPriceMain = productPriceMainBefore;
              }
              productPriceMain = productPriceMainBefore;

              if(priceEl && window.test_19_variation_0 == true){
                productPriceMain = Number(priceEl.querySelector('.price.test_id_19_price_var_0')?.getAttribute('data-test-19-price-control'));
              } else if(priceEl && window.test_19_variation_1 == true){
                productPriceMain = Number(priceEl.querySelector('.price.test_id_19_price_var_1')?.getAttribute('data-test-19-price-control'));
              } else if(priceEl && window.test_19_variation_2 == true){
                productPriceMain = Number(priceEl.querySelector('.price.test_id_19_price_var_2')?.getAttribute('data-test-19-price-control'));
              }
              
              if(productPriceMain == null || productPriceMain == 0 || productPriceMain == '' || isNaN(productPriceMain)){
                productPriceMain = productPriceMainBefore;
              }
              
              // On PDPs with Kaching Bundles the shopper pays the bundle total, not the
              // unit price — quote the installment off that so the banner matches checkout.
              var kachingTotalCents = getKachingBundleTotalCents();
              if(kachingTotalCents){
                productPriceMain = kachingTotalCents;
              }

              var productPrice = productPriceMain/100;
              var priceCurrency = new Intl.NumberFormat("en", { style: "currency", currency: window.Shopify.currency.active }).formatToParts(0).find((part) => part.type === "currency").value;
              var product4thPrice = productPrice/4;
              product4thPrice = Math.floor(product4thPrice*100)/100;
              product4thPrice = priceCurrency + product4thPrice
              //var shopPayUpdatedTxt = `or 4 interest-free installments of ${product4thPrice} with`;
              
              var shopPayBanner = shopPayTermsShadow.querySelector('#shopify-installments');
              var shopPayInstContent = shopPayBanner ? shopPayBanner.querySelector('#shopify-installments-content') : null;
              var shopPayInstCTA = shopPayBanner ? shopPayBanner.querySelector('#shopify-installments-cta') : null;
              var isStyle1 = shopPayWrapper.closest('.product') != null && shopPayWrapper.closest('.product').classList.contains('template-style_1');

              // Shopify owns the markup inside the banner — if it ever changes shape, show
              // the stock banner rather than leaving a hidden element behind.
              if(!shopPayInstContent){
                clearTimeout(shopPayFailsafe);
                clearInterval(shopPayInterval);
                shopPayWrapper.style.visibility = 'visible';
                return;
              }

              // update shop pay inner copy
              if(shopPayInstContent.querySelector('b') != null){
                shopPayInstContent.querySelector('b').innerHTML = product4thPrice;
              }
              if(shopPayInstContent.querySelector('.font-bold') != null){
                shopPayInstContent.querySelector('.font-bold').innerHTML = product4thPrice;
              }

              if(isStyle1){
                if(shopPayInstContent.querySelector('b') != null){
                  shopPayInstContent.querySelector('b').style.fontWeight = '400';
                }
                if(shopPayInstContent.querySelector('.font-bold') != null){
                  shopPayInstContent.querySelector('.font-bold').style.fontWeight = '400';
                }
                shopPayInstContent.style.fontSize = '14px';
                shopPayInstContent.style.lineHeight = '1.428';
                shopPayInstContent.style.letterSpacing = '0';
                shopPayInstContent.style.color = '#55526D';
                shopPayInstContent.style.paddingRight = '3px';

                if(shopPayInstCTA){
                  shopPayInstCTA.style.fontSize = '14px';
                  shopPayInstCTA.style.fontWeight = '700';
                  shopPayInstCTA.style.lineHeight = '1.428';
                  shopPayInstContent.style.letterSpacing = '0';
                  shopPayInstCTA.style.textUnderlineOffset = '2px';
                  shopPayInstCTA.style.color = '#EA5F54';
                }

                if(shopPayInstContent.querySelector('svg') != null){
                  shopPayInstContent.querySelector('svg').style.display = 'none';
                }
              }
      
              var nodeCount = 0;
              for (const shopPayNode of shopPayInstContent.childNodes) {
                if (shopPayNode.nodeType === Node.TEXT_NODE) {
                  nodeCount++;
                  if(nodeCount == 1){
                    if(isStyle1){
                      shopPayNode.textContent = `Pay in 4 installments of `;
                    }else{
                      shopPayNode.textContent = `Pay in 4 interest-free installments of `;
                    }
                  }else if(nodeCount == 2){
                    if(isStyle1){
                      shopPayNode.textContent = ` with ShopPay.`;
                    }else{
                      shopPayNode.textContent = ` with `;
                    }
                  }else{
                    shopPayNode.textContent = ``;
                  }
                  shopPayWrapper.classList.add('message-edited');
                  //console.log(shopPayNode.textContent);
                }
              }
              // update shop pay inner copy

              clearTimeout(shopPayFailsafe);
              shopPayWrapper.style.visibility = 'visible';
            }else{
              shopPayWrapper = document.querySelector('shopify-payment-terms');
            }
          }
    
          var shopPayInterval = setInterval(()=>{
            shopPayHandle();
          }, editInterval)
          
        }
      })
    }
  }

  hideOtherMedia(){

    let mediaGalleryMain = document.getElementById(`MediaGallery-${this.dataset.section}`);
    
    if(mediaGalleryMain.dataset.hideOtherVariant == 'true'){
      if(this.getVariantData()){
        mediaGalleryMain.dataset.activeSlide = "1";
        // console.log(this.getVariantData());
    
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    
        this.currentVariantDetails = this.getVariantData().find((variant) => {
          return !variant.options.map((option, index) => {
            return this.options[index] === option;
          }).includes(false);
        });
        if(this.currentVariantDetails.featured_media != null && this.currentVariantDetails.featured_media.alt != null){
          
          let variantTypeAll = Array.from(document.querySelectorAll('fieldset input')).find((radio) => radio.checked).getAttribute('name');
          let variantType = variantTypeAll;
          variantType = variantType.replace('options[', '');
          variantType = variantType.replace(']', '');
          variantType = variantType.toLowerCase();
      
          let currentVariantTitle;
      
          if(this.currentVariantDetails.option1.indexOf('BLISSFUL') != -1 && this.currentVariantDetails.option1.indexOf('BUNDLE') != -1){
            currentVariantTitle = 'BLISSFUL BUNDLE';
          }else{
            currentVariantTitle = this.currentVariantDetails.option1;
          }
      
          currentVariantTitle = currentVariantTitle.normalize('NFKD')
                                    .replace(/[\u0300-\u036f]/g, '')
                                    .trim()
                                    .toLowerCase()
                                    .replace(/[^a-z0-9 -]/g, '')
                                    .replace(/\s+/g, '-')
                                    .replace(/-+/g, '-');
          
          currentVariantTitle = `${variantType}_${currentVariantTitle}`;
          
          console.log(currentVariantTitle);
          
          let mediaGalleryViews = mediaGalleryMain.querySelectorAll(`#Slider-Gallery-${this.dataset.section} li`);
          let mediaGalleryThumbs = mediaGalleryMain.querySelectorAll(`#Slider-Thumbnails-${this.dataset.section} li`);
          let mediaGalleryPagination = mediaGalleryMain.querySelectorAll(`.slider-pagination .slider-pagination-link`);
      
          let mediaIsSet = false;
      
          mediaGalleryViews.forEach((mediaGalleryView)=>{
            let imgAlt = mediaGalleryView.querySelector(`.product__media img`).getAttribute('alt');
            if(imgAlt.indexOf(currentVariantTitle) == -1){
              mediaGalleryView.classList.add('custom-option_hidden');
            }else{
              mediaGalleryView.classList.remove('custom-option_hidden');
              if(!mediaIsSet){
                mediaGalleryMain.setActiveMedia(mediaGalleryView.dataset.mediaId, true);
                mediaIsSet = true;
              }
            }
          });
    
          let thumbIndex = 1;
          mediaGalleryThumbs.forEach((mediaGalleryThumb, index)=>{
            let imgAlt = mediaGalleryThumb.querySelector(`.thumbnail img`).getAttribute('alt');
            if(imgAlt.indexOf(currentVariantTitle) == -1){
              mediaGalleryThumb.classList.add('custom-option_hidden');
            }else{
              mediaGalleryThumb.classList.remove('custom-option_hidden');
              mediaGalleryThumb.dataset.mediaPosition = thumbIndex;
              thumbIndex++;
            }
          });
    
          // pagination handle
          mediaGalleryPagination.forEach((pagination, index)=>{
            pagination.classList.add('pagination-hidden');
            if((index+1) <= (thumbIndex-1)){
              pagination.classList.remove('pagination-hidden');
            }
          })
        }
        mediaGalleryMain.classList.remove('gallery-is-loading');
      }
    }
  }
}

customElements.define('variant-radios', VariantRadios); document.addEventListener('startasyncloading', function() {
  if(document.querySelector('dom-html')){
    document.querySelector('dom-html').remove();
  }
});


function pillowColorOptionHandle(colorDropdownOptions, currentVariantDetails, getVariantData, productId, isUpsell, element) {

  let applicableTemplates = ['bmp-colors', 'combo-colors', 'cover-colors', 'pillow2_new_copy', 'pillow2_new_copy_v2', 'pillow2_new_badges_all', 'pillow2_new_copy_test', 'fba-colors', 'ice-cool-bmp', 'bundle2'];
  let applicableCountries = ['US', 'GB'];

  let productElement = element.closest('.product');
  
  let featureProductClass = ['featured-product', 'show_custom_variant_swatches'];
  
  let isFeaturedProduct = featureProductClass.every(cls => productElement.classList.contains(cls));
  let isSectionVisible = true;
  if(element.closest('.shopify-section.section').style.display == 'none'){
    isSectionVisible = false;
    isFeaturedProduct = false;
  }

  let pillowColorCodes = {
    Cream: '#EDE1D7',
    Turquoise: '#d3dfce',
    Peach: '#eac8b8'
  };

  if (applicableTemplates.indexOf(window._template.suffix) != -1 || isFeaturedProduct) {
    
    let dropdownInputs = productElement.querySelectorAll('variant-selects .product-form__input');
    dropdownInputs.forEach((input) => {
      let inputLabel = input.querySelector('label').innerHTML.trim();
      if (inputLabel == 'Color' || inputLabel == 'Colour') {
        input.classList.add('hidden');
      }
      input.style.opacity = 1;
    });
  }

  fetch('https://api.country.is/', {
    method: 'GET'
  })
    .then(response => response.json())
    .then(response => {
      // console.log(response.country);
      isCountry = true;
      country_code = response.country;
      if (isCountry) {
        // if (applicableCountries.indexOf(country_code) != -1) {
          // if country matched

          if (applicableTemplates.indexOf(window._template.suffix) != -1 || isFeaturedProduct) {

            // color option code

            let originalAtcButton, targetParentContainer;
            
            let colorSwatchBtn;

            let upsellClass = 'current-product';
            if(isUpsell){
              upsellClass = 'upsell-product hidden';
            }

            let upsellThumbnail = productElement.querySelector(`.BBB-UPSELL-option[data-product-id="${productId}"] img`);

            if(productElement.classList.contains('upsell-tabs')){
              targetParentContainer = productElement.querySelectorAll(".UPSELL-tabs-section .UPSELL-tabs-form-colors");
              targetParentContainer.forEach((el)=>{
                el.insertAdjacentHTML("afterbegin",
                  `
               <div class="bbb-pillow-product-form__colors ${upsellClass}" data-product="${productId}">
                 <label class="form__label" for="Quantity-template--14551777607779__main">
                   <strong>Color: </strong> <span></span>
                 </label>
                 <div class="bbb-pillow-product-form__colors-options">
                 </div>
               </div>
               `);
              })
            }else if(productElement.classList.contains('upsell-buttons_with_colors')){
              targetParentContainer = productElement.querySelectorAll(".BBB-UPSELL-options-section .BBB-UPSELL-option-form-colors");
              targetParentContainer.forEach((el)=>{
                el.insertAdjacentHTML("afterbegin",
                  `
               <div class="bbb-pillow-product-form__colors ${upsellClass}" data-product="${productId}">
                 <label class="form__label" for="Quantity-template--14551777607779__main">
                   <strong>Color: </strong> <span></span>
                 </label>
                 <div class="bbb-pillow-product-form__colors-options">
                 </div>
               </div>
               `);
              })
              upsellThumbnail = productElement.querySelector(`.BBB-UPSELL-option-with-colors[data-product-id="${productId}"] img`);
            }else{
              if(isFeaturedProduct){
                originalAtcButton = productElement.querySelector(".product-form-btn-wrapper form button.product-form__submit");
              }else{
                originalAtcButton = productElement.querySelector(".product-buy_button form button.product-form__submit");
              }
              targetParentContainer = originalAtcButton.parentNode;
              targetParentContainer.insertAdjacentHTML("afterbegin",
                `
             <div class="bbb-pillow-product-form__colors ${upsellClass}" data-product="${productId}">
               <div class="bbb-pillow-product-form__colors-options">
               </div>
               <label class="form__label" for="Quantity-template--14551777607779__main" style="margin-top: 10px;">
                 <strong>Color: </strong> <span></span>
               </label>
             </div>
             `);
            }
            
            

            let allColorOptions = productElement.querySelectorAll(`.bbb-pillow-product-form__colors[data-product="${productId}"]`);
            
            let colorButtonsContainer;
            if(isFeaturedProduct){
              colorButtonsContainer = productElement.querySelectorAll(".product-form-btn-wrapper form .bbb-pillow-product-form__colors-options");
            }else{
              // colorButtonsContainer = productElement.querySelectorAll(".product-buy_button form .bbb-pillow-product-form__colors-options");
              colorButtonsContainer = productElement.querySelectorAll(`.product-buy_button form .bbb-pillow-product-form__colors[data-product="${productId}"] .bbb-pillow-product-form__colors-options`);
            }

            var upsellCurrentProductOptions = productElement.querySelectorAll('.BBB-UPSELL-option.BBB-UPSELL-current-option');
            var currentUpsellOption = upsellCurrentProductOptions[0];

            if(colorDropdownOptions.length > 0){
              colorDropdownOptions.forEach((option) => {
                let currentVarientBtnClass = "";
                if (currentVariantDetails.title.indexOf(option.value) != -1) {
                  currentVarientBtnClass = "bbb-pillow-selected";
                  allColorOptions.forEach((block)=>{
                    block.querySelector("label span").innerText = option.value;
                  })
                } else {
                  currentVarientBtnClass = "";
                }

                colorSwatchBtn = `<button class="${currentVarientBtnClass}" data-color="${option.value}">
                                        <span class="bbb-pillow-product-form__colors-options-rounded" style="background-color: ${pillowColorCodes[option.value]}"></span>
                                        <span style="display: none;" class="bbb-pillow-label-name">${option.value}</span>
                                    </button>`;

                colorButtonsContainer.forEach((el)=>{
                  el.insertAdjacentHTML("beforeend", colorSwatchBtn);
                })
              });
            }else{
              colorButtonsContainer.closest(".BBB-UPSELL-option-with-colors-footer").style.display = 'none';
            }

            let colorButtons = productElement.querySelectorAll(`.bbb-pillow-product-form__colors-options button`);

            let colorDropdown = productElement.querySelector('[name="options[Color]"]');
            let allDropdowns = productElement.querySelectorAll('.product-form__input select');

            colorButtons.forEach((button) => {
              button.addEventListener("click", (e) => {
                e.preventDefault();

                let currentColorOptions = button.closest(`.bbb-pillow-product-form__colors[data-product="${productId}"]`);
                let colorLabel = currentColorOptions.querySelector("label span");

                // select button
                let selectedColours = productElement.querySelectorAll(`.bbb-pillow-product-form__colors button.bbb-pillow-selected`);
                selectedColours.forEach((selectedColour)=>{
                  if (selectedColour) selectedColour.classList.remove(`bbb-pillow-selected`);
                })

                let otherColours = productElement.querySelectorAll(`.bbb-pillow-product-form__colors button`);
                otherColours.forEach((otherColour)=>{
                  if (otherColour.dataset.color == button.dataset.color) {
                    otherColour.classList.add(`bbb-pillow-selected`);
                  }
                })
                // select button

                // change label
                let allColourLabels = productElement.querySelectorAll(".bbb-pillow-product-form__colors");

                colorLabel.innerText = button.dataset.color;

                let globalColourLabels = productElement.querySelectorAll(".BBB-UPSELL-option-with-colors-footer-txt");

                globalColourLabels.forEach((label)=>{
                  label.querySelector("span").innerText = button.dataset.color;
               })
                
                allColourLabels.forEach((label)=>{
                  label.querySelectorAll('button').forEach((btn)=>{
                    if(btn.dataset.color == button.dataset.color) {
                      label.querySelector(".bbb-pillow-product-form__colors label span").innerText = button.dataset.color;
                      
                    }
                  })
               })
                // change label

                // IF Vtl sticky ADC
                let vtlStickyAdc = document.querySelector('.Vtl-VariantSelector');

                button.classList.add(`bbb-pillow-selected`);

                let allOtherVariantsTitles = [...productElement.querySelectorAll('.product-form__input select')]
                .filter(s => s.name !== 'options[Color]')
                .map(s => s.value)
                .join(' / ');

                let upsellVariantTypes = [];
                let completeVariantTitle = button.dataset.color;
                
                if(productId != ''){
                  let relUpsellOption = productElement.querySelector(`.BBB-UPSELL-option[data-product-id="${productId}"]`);
                  upsellVariantTypes = JSON.parse(relUpsellOption.getAttribute('data-variant-type'));
                  if(allOtherVariantsTitles != '' && upsellVariantTypes.length > 1){
                    completeVariantTitle = `${button.dataset.color} / ${allOtherVariantsTitles}`;
                  }
                }else{
                  if(allOtherVariantsTitles != ''){
                    completeVariantTitle = `${button.dataset.color} / ${allOtherVariantsTitles}`;
                  }
                }
                
                
                getVariantData.forEach((variant, index) => {
                  // let allMatch = Array.from(productElement.querySelectorAll('.product-form__input select')).every(dropdown => {
                  //   if (dropdown.getAttribute('name') === 'options[Color]') return true;
                  //   return variant.title.indexOf(dropdown.value) !== -1;
                  // });
                  
                  // if (variant.title.indexOf(button.dataset.color) != -1 && allMatch) {

                  //   console.log(variant);
                    
                  //   if (colorDropdown) colorDropdown.value = button.dataset.color;
                  //   // if (vtlStickyAdc) vtlStickyAdc.value = variant.id;
  
                  //   if(currentColorOptions.dataset.product == ''){
                  //     colorDropdown.dispatchEvent(new Event('change', { bubbles: true }));
                  //   }
  
                  //   productElement.querySelector('form.form input[name="id"]').value = variant.id;
  
                  // }

                  if (variant.title.indexOf(completeVariantTitle) != -1) {
                    
                    if (colorDropdown) colorDropdown.value = button.dataset.color;
                    // if (vtlStickyAdc) vtlStickyAdc.value = variant.id;
  
                    if(currentColorOptions.dataset.product == ''){
                      colorDropdown.dispatchEvent(new Event('change', { bubbles: true }));
                    }
  
                    productElement.querySelector('form.form input[name="id"]').value = variant.id;
  
                  }
                })

                
                // ID set code ends

                // image gallery updation
                if(currentColorOptions.dataset.product != ''){

                  let upsellProductOptions = productElement.querySelectorAll('.BBB-UPSELL-options-section .BBB-UPSELL-option:nth-of-type(n+2)');

                  upsellProductOptions.forEach((upsellOption)=>{
                    if(upsellOption.getAttribute('data-product-id') == currentColorOptions.dataset.product){
                      newProductGalleryImages = JSON.parse(upsellOption.dataset.images);
                    }
                  })
                  
                  let mediaGalleryMain = productElement.querySelector(`media-gallery.product__media-gallery`);
                  let mediaGalleryId = mediaGalleryMain.id;
                  let sectionId = getSectionId(mediaGalleryId);
                  
                  let newProductGalleryHTML = newProductGalleryImages.map((image, index) => `
                    <li id="Slide-template--${sectionId}__main-${image.id}" class="product__media-item grid__item slider__slide" data-media-id="template--${sectionId}__main-${image.id}" role="presentation">
                      <modal-opener class="product__modal-opener product__modal-opener--image no-js-hidden" data-modal="#ProductModal-template--${sectionId}__main">
                        <span class="product__media-icon motion-reduce" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.66724 7.93978C4.66655 7.66364 4.88984 7.43922 5.16598 7.43853L10.6996 7.42464C10.9758 7.42395 11.2002 7.64724 11.2009 7.92339C11.2016 8.19953 10.9783 8.42395 10.7021 8.42464L5.16849 8.43852C4.89235 8.43922 4.66793 8.21592 4.66724 7.93978Z" fill="currentColor"></path>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.92576 4.66463C8.2019 4.66394 8.42632 4.88723 8.42702 5.16337L8.4409 10.697C8.44159 10.9732 8.2183 11.1976 7.94215 11.1983C7.66601 11.199 7.44159 10.9757 7.4409 10.6995L7.42702 5.16588C7.42633 4.88974 7.64962 4.66532 7.92576 4.66463Z" fill="currentColor"></path>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8324 3.03011C10.1255 0.323296 5.73693 0.323296 3.03011 3.03011C0.323296 5.73693 0.323296 10.1256 3.03011 12.8324C5.73693 15.5392 10.1255 15.5392 12.8324 12.8324C15.5392 10.1256 15.5392 5.73693 12.8324 3.03011ZM2.32301 2.32301C5.42035 -0.774336 10.4421 -0.774336 13.5395 2.32301C16.6101 5.39361 16.6366 10.3556 13.619 13.4588L18.2473 18.0871C18.4426 18.2824 18.4426 18.599 18.2473 18.7943C18.0521 18.9895 17.7355 18.9895 17.5402 18.7943L12.8778 14.1318C9.76383 16.6223 5.20839 16.4249 2.32301 13.5395C-0.774335 10.4421 -0.774335 5.42035 2.32301 2.32301Z" fill="currentColor"></path>
                      </svg>
                      </span>
                      <div class="product__media media media--transparent gradient global-media-settings" style="padding-top: 100.0%;">
                        <img srcset="${image.src}" src="${image.src}" width=1946" sizes="(min-width: 1000px) 495px, (min-width: 990px) calc(55.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)" loading="lazy" width="973" height="973" alt="${image.alt}">
                      </div>
                      <button class="product__media-toggle" type="button" aria-haspopup="dialog" data-media-id="${image.id}">
                        <span class="visually-hidden">
                          Open media ${index+1} in modal
                        </span>
                      </button>
                      </modal-opener>
                    </li>
                  `).join("");

                  let newThumbnailImagesHTML = newProductGalleryImages.map((image, index) => `
                    <li id="Slide-Thumbnails-template--${sectionId}__main-${index}" class="thumbnail-list__item slider__slide" data-target="template--${sectionId}__main-${image.id}" data-media-position="${index}">
                      <button class="thumbnail global-media-settings global-media-settings--no-shadow thumbnail--narrow" aria-label="Load image 2 in gallery view" aria-controls="GalleryViewer-template--${sectionId}__main" aria-describedby="Thumbnail-template--${sectionId}__main-2">
                        <img id="Thumbnail-template--${sectionId}__main-2" class="thumbnail_img" srcset="${image.src}" src="${image.src}" sizes="(min-width: 1200px) calc((1200px - 19.5rem) / 12), (min-width: 750px) calc((100vw - 16.5rem) / 8), calc((100vw - 8rem) / 5)" alt="${image.alt}" height="200" width="200" loading="lazy">
                      </button>
                    </li>
                    `).join("");

                  let newModalImages = newProductGalleryImages.map(image => `
                  <img class="global-media-settings global-media-settings--no-shadow" srcset="${image.src}" sizes="(min-width: 750px) calc(100vw - 22rem), 1100px" src="${image.src}" alt="${image.alt}" loading="lazy" width="1100" height="1100" data-media-id="${image.id}">
                  `).join("");

                  let modalImageHTML = document.querySelector(".product-media-modal__content");
                  modalImageHTML.innerHTML = newModalImages;
    
                  productElement.querySelectorAll(".product__media-list li").forEach((li, index) => {
                    let button = li.querySelector(".product__media-toggle"); 
                    if (button) {
                      button.innerHTML = `<span class="visually-hidden">Open media ${index + 1} in modal</span>`; 
                    };
                  });

                  let parser = new DOMParser();
                  
                  let newProductGalleryHTMLDOC = parser.parseFromString(newProductGalleryHTML, 'text/html');
                  newProductGalleryHTML = newProductGalleryHTMLDOC.querySelectorAll('li');

                  let newThumbnailImagesHTMLDOC = parser.parseFromString(newThumbnailImagesHTML, 'text/html');
                  newThumbnailImagesHTML = newThumbnailImagesHTMLDOC.querySelectorAll('li');

                  let currentVariantTitle = `color_${button.dataset.color.toLowerCase()}`;
                  localStorage.setItem('selected_variant_title', currentVariantTitle);

                  // console.log(newProductGalleryHTML);
  
                  // set image of index 2 and 3
                  let indicesToRemove = [];
                  // let updatedMediaGalleryViews = Array.from(mediaGalleryViews);
                  // let updatedMediaGalleryThumbs = Array.from(mediaGalleryThumbs);

                  let updatedMediaGalleryViews = Array.from(newProductGalleryHTML);
                  let updatedMediaGalleryThumbs = Array.from(newThumbnailImagesHTML);
        
                  // console.log(updatedMediaGalleryThumbs);
        
                  let currentVariantPos = 0;

                  let fixedViewsImages = [];
                  let fixedThumbImages = [];
                  
                  newProductGalleryHTML.forEach((mediaGalleryView, index)=>{
                    if(getVariantData.every(variant => mediaGalleryView.querySelector(`.product__media img`).getAttribute('alt').indexOf(variant.title.toLowerCase()) !== -1)){
                      let fixedViewsImageObj = {
                        id: (index - currentVariantPos),
                        el: mediaGalleryView
                      }
                      fixedViewsImages.push(fixedViewsImageObj);
                      indicesToRemove.push(index);
                    }
                  })
        
                  newThumbnailImagesHTML.forEach((mediaGalleryThumb, index)=>{
                    if(getVariantData.every(variant => mediaGalleryThumb.querySelector(`.thumbnail img`).getAttribute('alt').indexOf(variant.title.toLowerCase()) !== -1)){
                      let fixedThumbImageObj = {
                        id: (index - currentVariantPos),
                        el: mediaGalleryThumb
                      }
                      fixedThumbImages.push(fixedThumbImageObj);
                    }
                  })
                  
                  indicesToRemove.sort((a, b) => b - a);
                  for (const index of indicesToRemove) {
                    if (index >= 0 && index < updatedMediaGalleryViews.length) {
                      updatedMediaGalleryViews.splice(index, 1);
                    }
                    if (index >= 0 && index < updatedMediaGalleryThumbs.length) {
                      updatedMediaGalleryThumbs.splice(index, 1);
                    }
                  }
                  // set image of index 2 and 3
        
                  let mediaIsSet = false;
                  
                  mediaGalleryMain.querySelectorAll(`#Slider-Thumbnails-template--${sectionId}__main li`).forEach((mediaGalleryThumb)=>{
                    mediaGalleryThumb.remove();
                  })
                  
                  updatedMediaGalleryThumbs.forEach((mediaGalleryThumb, index)=>{
                    let imgAlt = mediaGalleryThumb.querySelector(`.thumbnail img`).getAttribute('alt');
                    if(imgAlt.indexOf(currentVariantTitle) == -1){
                    }else{
                      productElement.querySelector(`.thumbnail-list.slider`).append(mediaGalleryThumb);
                      productElement.querySelector(`.thumbnail-list.slider`).dispatchEvent(new Event('resize'));
                    }
                  });
        
                  mediaGalleryMain.querySelectorAll(`#Slider-Gallery-template--${sectionId}__main li`).forEach((mediaGalleryView)=>{
                    mediaGalleryView.remove();
                  })

                  let currentVariantFeaturedMediaSet = false;
                  let currentVariantFeaturedMedia;
                  updatedMediaGalleryViews.forEach((mediaGalleryView)=>{
                    let imgAlt = mediaGalleryView.querySelector(`.product__media img`).getAttribute('alt');
                    if(imgAlt.indexOf(currentVariantTitle) == -1){
                    }else{
                      // console.log(mediaGalleryView);
                      if(!currentVariantFeaturedMediaSet){
                        currentVariantFeaturedMedia = mediaGalleryView;
                        currentVariantFeaturedMediaSet = true;
                      }
                      productElement.querySelector(`.product__media-list.slider`).append(mediaGalleryView);
                      if(!mediaIsSet){
                        mediaGalleryMain.setActiveMedia(mediaGalleryView.dataset.mediaId, true);
                        mediaIsSet = true;
                      }
                    }
                  });
                  mediaGalleryMain.dataset.activeSlide = "1";
                  
                  // set image of index 2 and 3
                  fixedViewsImages.forEach((fixImg)=>{
                    productElement.querySelector(`.product__media-list.slider`).insertBefore(fixImg.el, productElement.querySelectorAll(`.product__media-list.slider li`)[fixImg.id]);
                  })
                  fixedThumbImages.forEach((fixThumb)=>{
                    productElement.querySelector(`.thumbnail-list.slider`).insertBefore(fixThumb.el, productElement.querySelectorAll(`.thumbnail-list.slider li`)[fixThumb.id]);
                  })
                  // set image of index 2 and 3

                  let updatedMediaGalleryThumbs2 = productElement.querySelectorAll(`.thumbnail-list.slider li`);
                  let thumbIndex = 1;
                  updatedMediaGalleryThumbs2.forEach((mediaGalleryThumb)=>{
                    mediaGalleryThumb.setAttribute('data-media-position', thumbIndex);
                    thumbIndex++;
                  });

                  let newSliderComponents = mediaGalleryMain.querySelectorAll('slider-component');
                  newSliderComponents.forEach((newSliderComponent)=>{
                    newSliderComponent.resetPages();
                    // newSliderComponent.update();
                  })

                  // update media currentVariantTitle
                  
                  mediaGalleryMain = productElement.querySelector(`media-gallery.product__media-gallery`);
                  mediaGalleryMain.setActiveMedia(`${currentVariantFeaturedMedia.getAttribute('data-media-id')}`, true);

                  // thumbnail image set
                  upsellCurrentProductOptions = productElement.querySelectorAll('.BBB-UPSELL-option:not(.extra)');

                  function countCharacter(str, char) {
                     const regex = new RegExp(char, 'gi'); // 'g' for global, 'i' for case-insensitive
                     const matches = str.match(regex);
                     return matches ? matches.length : 0;
                   }
        
                  if(upsellCurrentProductOptions.length){
                    upsellCurrentProductOptions.forEach((upsellOption)=>{
                      let isThumbnailSet = false;
                      let newProductGalleryImages = JSON.parse(upsellOption.dataset.images);
                      newProductGalleryImages.forEach((data)=>{
                        if(countCharacter(data.alt, '#color') == 1 && data.alt.indexOf(`#${currentVariantTitle}`) != -1){
                          if(!isThumbnailSet){
                            currentUpsellOption = upsellOption;
                            upsellOption.querySelector('img').src = data.src;
                            isThumbnailSet = true;
                          }
                        }
                      })
                    })
                  }
                  
                  upsellThumbnail.src = currentVariantFeaturedMedia.querySelector(`.product__media img`).getAttribute('srcset');

                  // dynamic image set
                  let dynamicImages = document.querySelectorAll('[data-product-image-index]');
                  dynamicImages.forEach((img)=>{
                    let imgDynamicIndex = Number(img.dataset.productImageIndex) - 1;
                    img.setAttribute('srcset', productElement.querySelectorAll(`.product__media-list.slider li`)[imgDynamicIndex].querySelector('img').getAttribute('srcset'));
                    img.setAttribute('src', productElement.querySelectorAll(`.product__media-list.slider li`)[imgDynamicIndex].querySelector('img').getAttribute('src'));
                  })
                  // dynamic image set
                  let galleryNew = productElement.querySelector('media-gallery');
                  galleryNew.init();
                }
                // image gallery updation
                
              });
            });

            // color option code
          }
          // if country matched
        // }
      }
    })
    .catch(error => {
      console.error('Error: ' + error);
    });
}

function updateTestPrice(price){

  // Test Price Related 
  let upsell_product_id = price.dataset.productId;
  let upsell_compare_at_price = Number(price.dataset.compareAtPrice);
  let upsell_compare_at_price_money = price.dataset.compareAtPriceMoney;
  let upsell_price = Number(price.dataset.price);
  let upsell_price_money = price.dataset.priceMoney;

  let test_upsell_badge_text_var_0 = price.getAttribute('data-test-19-badge-text-control');
  let test_upsell_badge_text_var_1 = price.getAttribute('data-test-19-badge-text-var-one');
  let test_upsell_badge_text_var_2 = price.getAttribute('data-test-19-badge-text-var-two');


   if(window.test_19_variation_0 == true){
    upsell_compare_at_price = Number(price.getAttribute('data-test-19-compare-at-price-control'));
    upsell_compare_at_price_money = price.getAttribute('data-test-19-compare-at-price-money-control');
    upsell_price = Number(price.getAttribute('data-test-19-price-control'));
    upsell_price_money = price.getAttribute('data-test-19-price-money-control');
  } else if(window.test_19_variation_1 == true){
    upsell_compare_at_price = Number(price.getAttribute('data-test-19-compare-at-price-var-one'));
    upsell_compare_at_price_money = price.getAttribute('data-test-19-compare-at-price-money-var-one');
    upsell_price = Number(price.getAttribute('data-test-19-price-var-one'));
    upsell_price_money = price.getAttribute('data-test-19-price-money-var-one');
  } else if(window.test_19_variation_2 == true){
    upsell_compare_at_price = Number(price.getAttribute('data-test-19-compare-at-price-var-two'));
    upsell_compare_at_price_money = price.getAttribute('data-test-19-compare-at-price-money-var-two');
    upsell_price = Number(price.getAttribute('data-test-19-price-var-two'));
    upsell_price_money = price.getAttribute('data-test-19-price-money-var-two');
  }

  if(upsell_price == null || upsell_price == 0 || upsell_price == ''){
        
      }else{

    price.querySelectorAll('.price-item--regular').forEach((el)=>{
      el.innerHTML = upsell_compare_at_price_money;
      el.dataset.productId = upsell_product_id;
    });

    price.querySelectorAll('.price-item--sale').forEach((el)=>{
      el.innerHTML = upsell_price_money;
      el.dataset.productId = upsell_product_id;
    });
  // Test Price Related 
  
  // badge text
  document.querySelectorAll('.price__badge-sale').forEach((el)=>{
    if(upsell_compare_at_price && upsell_compare_at_price > upsell_price){
      let discount = upsell_compare_at_price - upsell_price;
      let savings = (discount * 100) / upsell_compare_at_price;
      let perc_savings = Math.ceil(savings / 5) * 5;
      let updated_badge_text = price.querySelector('.price').getAttribute('data-badge-text');
      if(window.test_19_variation_0 == true && test_upsell_badge_text_var_0){
        el.innerHTML = test_upsell_badge_text_var_0;
      } else if(window.test_19_variation_1 == true && test_upsell_badge_text_var_1){
        el.innerHTML = test_upsell_badge_text_var_1;
      } else if(window.test_19_variation_2 == true && test_upsell_badge_text_var_2){
        el.innerHTML = test_upsell_badge_text_var_2;
      } else{
        // el.innerHTML = `${perc_savings}% OFF`;
        el.innerHTML = updated_badge_text;
      }
      el.dataset.productId = upsell_product_id;
    }
  });
  // badge text

  // shop pay
  
  let product4thPriceNumb = upsell_price / (4 * 100);
  product4thPriceNumb = Math.floor(product4thPriceNumb * 100) / 100;
  
  let product4thPrice = upsell_price_money.replace("<span class=money>", "");
  product4thPrice = product4thPrice.replace("</span>", "");
  product4thPrice = product4thPrice.replace(".00", "");
  product4thPrice = product4thPrice.replace((upsell_price/100), product4thPriceNumb);
  
  document.querySelectorAll('shopify-payment-terms').forEach((shopPayWrapper) => {
    shopPayHandle(shopPayWrapper, product4thPrice);
  })
  }
}

function getSectionId(mediaGalleryId) {
  let match = mediaGalleryId.match(/template--(\d+)__/);
  return match ? match[1] : null;
}